var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"25","y":"1","width":"24","height":"24","rx":"1","transform":"rotate(90 25 1)","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.88879 13.8889L10.3332 18.3333L20.111 8.55554","stroke":"#212355","strokeWidth":"1.5","strokeLinecap":"round","key":1})]);
}

CheckInline.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
